import { render, staticRenderFns } from "./AlimentosEdit.vue?vue&type=template&id=a5be1718&"
import script from "./AlimentosEdit.vue?vue&type=script&lang=js&"
export * from "./AlimentosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports